import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {EditorService} from '../../../../../services/editor.service';

@Component({
  selector: 'app-form-templates',
  templateUrl: './form-templates.component.html',
  styleUrls: ['./form-templates.component.scss']
})
export class FormTemplatesComponent implements OnInit {
  templates = [];
  selectedTemplate: number;
  constructor(public dialogRef: MatDialogRef<FormTemplatesComponent>,
              private editorService: EditorService) { }

  ngOnInit(): void {
    this.templates = this.editorService.templates;
    this.selectedTemplate = -1;
  }

  setSelectedTemplate(index) {
    this.selectedTemplate = index;
  }

  returnSelected() {
    const selected = this.templates[this.selectedTemplate];
    this.close(selected.rows);
  }

  close(rows?: any) {
    this.dialogRef.close(rows);
  }

}
